<section
  class="flex font-open-sans min-h-0 flex-1 flex-col overflow-hidden rounded-3xl border border-border-solid bg-[color-mix(in_srgb,var(--card)_70%,transparent)] shadow-[0_4px_16px_rgba(0,0,0,0.08)] backdrop-blur-[8px] max-sm:rounded-2xl">
  <header
    class="flex items-center justify-between gap-4 border-b border-border-solid-50 px-7 py-5 max-sm:flex-col max-sm:items-start max-sm:gap-3 max-sm:px-4 max-sm:py-3">
    <div class="flex items-center gap-3">
      <h2 class="header-lg text-foreground max-sm:text-base">{{ 'ACCESS.CHECKIN.LIVE_PICKUP.WAITING_LIST_TITLE' |
        translate }}</h2>
    </div>

    @if (!hasError() && !isLoading() && students().length > 0) {
    <div class="flex items-center gap-2 max-sm:w-full max-sm:flex-wrap">
      <lib-badge type="secondary">
        <span>{{ priorityCounts().normal }} {{ 'ACCESS.CHECKIN.LIVE_PICKUP.PRIORITY.NORMAL' | translate }}</span>
      </lib-badge>
      <lib-badge type="warning">
        <span>{{ priorityCounts().attention }} {{ 'ACCESS.CHECKIN.LIVE_PICKUP.PRIORITY.ATTENTION' | translate }}</span>
      </lib-badge>
      <lib-badge type="danger">
        <span>{{ priorityCounts().critical }} {{ 'ACCESS.CHECKIN.LIVE_PICKUP.PRIORITY.CRITICAL' | translate }}</span>
      </lib-badge>
    </div>
    }
  </header>

  <div
    [@.disabled]="isLoading() || students().length === 0"
    class="custom-scrollbar-thin flex min-h-[342px] flex-1 flex-col gap-2.5 overflow-y-auto overflow-x-hidden p-5 max-sm:p-3 max-sm:gap-2">
    @if (isLoading()) {
    @for (row of skeletonRows; track row) {
    <article
      class="relative grid grid-cols-[auto_1fr_auto_auto] items-center gap-5 overflow-hidden rounded-2xl border border-border-solid bg-card p-4 pl-6 max-sm:grid-cols-[auto_1fr_auto] max-sm:gap-3 max-sm:p-3 max-sm:pl-4">
      <lib-skeleton-loader [count]="1"
        [theme]="{ width: '48px', height: '48px', borderRadius: '9999px', margin: '0' }"></lib-skeleton-loader>
      <div class="flex min-w-0 flex-col gap-2">
        <lib-skeleton-loader [count]="1"
          [theme]="{ width: '60%', height: '24px', borderRadius: '6px', margin: '0' }"></lib-skeleton-loader>
        <lib-skeleton-loader [count]="1"
          [theme]="{ width: '40%', height: '16px', borderRadius: '6px', margin: '0' }"></lib-skeleton-loader>
      </div>
      <lib-skeleton-loader [count]="1"
        [theme]="{ width: '88px', height: '36px', borderRadius: '10px', margin: '0' }"></lib-skeleton-loader>
      <div class="flex min-w-[120px] flex-col items-end gap-1.5">
        <lib-skeleton-loader [count]="1"
          [theme]="{ width: '80px', height: '28px', borderRadius: '6px', margin: '0' }"></lib-skeleton-loader>
        <lib-skeleton-loader [count]="1"
          [theme]="{ width: '92px', height: '12px', borderRadius: '6px', margin: '0' }"></lib-skeleton-loader>
      </div>
    </article>
    }
    } @else if (hasError()) {
    <lib-error-state (retry)="retry.emit()" />
    } @else {
    @for (student of students(); track student.id) {
    @let priority = getPriority(student.waitSeconds);
    @let config = getPriorityConfig(priority);
    <div [@removeCheckin] class="block h-[94px] overflow-hidden [contain:layout_paint]">
    <article
      class="relative grid h-full grid-cols-[40px_1fr_auto_auto] items-center gap-5 overflow-hidden rounded-2xl border p-4 pl-6 transition-transform duration-200 max-sm:grid-cols-[40px_1fr_auto] max-sm:gap-3 max-sm:p-3 max-sm:pl-4"
      [ngClass]="[config.bg, config.border]"
      [class.novo-checkin]="highlightedIds().includes(student.id)">
      @if (highlightedIds().includes(student.id)) {
      <div class="highlight-overlay" aria-hidden="true"></div>
      }

      <lib-avatar [tooltipFollowDisabled]="true" size="sm" class="block h-10 w-10 shrink-0 overflow-hidden"
        [personId]="student.studentPersonId" />

      <div class="min-w-0 max-sm:col-span-2">
        <h3 class="mb-1 text-[28px] font-bold leading-tight tracking-tight text-foreground max-sm:text-lg max-sm:mb-0.5"
          style="text-wrap: balance">
          {{ student.name }}
        </h3>
        <p class="content-regular flex flex-wrap items-center gap-2 text-foreground-75 max-sm:content-sm-regular">
          <!-- TODO(live-pickup): reativar quando o backend enviar StudentClassDisplay.
          <span>{{ student.className }}</span>
          -->
          @if (student.responsibleName) {
          <i class="fi fi-rr-user text-[13px] leading-none text-foreground-50"></i>
          <span>{{ student.responsibleName }}</span>
          }
        </p>
      </div>

      <div
        class="flex items-center gap-2 rounded-[10px] border border-border-solid bg-secondary px-3.5 py-2 text-foreground-75 max-sm:col-start-2 max-sm:col-end-3 max-sm:row-start-2 max-sm:justify-self-start max-sm:px-2.5 max-sm:py-1">
        <i class="fi fi-rr-marker text-[14px] leading-none"></i>
        <span class="content-semibold">{{ student.gate }}</span>
      </div>

      <div class="min-w-[120px] text-right max-sm:col-start-3 max-sm:col-end-4 max-sm:row-start-2 max-sm:min-w-0">
        <div class="text-[32px] font-semibold leading-none tracking-tight tabular-nums max-sm:text-xl"
          [ngClass]="config.text">
          {{ student.waitTime }}
        </div>
        <p class="content-sm-regular text-foreground-50">{{ 'ACCESS.CHECKIN.LIVE_PICKUP.WAIT_TIME' | translate }}</p>
      </div>
    </article>
    </div>
    } @empty {
    <div class="m-3 flex min-h-0 flex-1 flex-col items-center justify-center px-8 py-14 text-center">
      <h3 class="mb-2 max-w-[420px] text-[20px] font-semibold leading-tight tracking-tight text-foreground">
        {{ 'ACCESS.CHECKIN.LIVE_PICKUP.WAITING_EMPTY_TITLE' | translate }}
      </h3>
      <p class="content-regular max-w-[380px] text-muted-foreground">
        {{ 'ACCESS.CHECKIN.LIVE_PICKUP.WAITING_EMPTY_DESCRIPTION' | translate }}
      </p>
      <lib-badge class="mt-5" type="outline">
        <div class="flex items-center gap-[6px]">
          <span class="relative inline-flex h-2 w-2 items-center justify-center">
            <span class="animate-smooth-ping absolute h-5 w-5 rounded-full bg-success"></span>
            <span
              class="relative h-2 w-2 rounded-full bg-success [box-shadow:0_0_0_3px_color-mix(in_srgb,var(--success)_25%,transparent)]"></span>
          </span>
          <p> {{ 'ACCESS.CHECKIN.LIVE_PICKUP.MONITORING_LIVE' | translate }}</p>
        </div>
      </lib-badge>
    </div>
    }
    }
  </div>
</section>